/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/icon/icon');
require('components/base/bubble/bubble');

const { apiPath } = require('appService/api');
const { setLoginInfo } = require('appVuex/action/login');

const store = require('appVuex/store');
const alert = require('components/base/pop/alert');
const tip = require('components/base/pop/tip');
const ajaxHttp = require('appUtil/ajaxHttp');
const spinner = require('components/base/loading/spinner');

require('./header-layout.scss');

const template = require('./header-layout.tpl');

module.exports = {
  template,

  props:{
    breadCrumbData: Object
  },

  data() {
    return {
      toggleFlag: false,
      loginInfo: {}
    }
  },

  vuex: {
    getters: {
    },
    actions: {
      setLoginInfo
    }
  },

  store,

  methods: {
    _init() {
      this.loadUserInfo();
    },

    loadUserInfo() {
      ajaxHttp(apiPath.login.userInfo, {
        type: "GET"
      }).then((res)=>{
        this.loginInfo = res.data;
        this.setLoginInfo(this.loginInfo);
      }).catch((res)=>{
        tip(res.message);
      });
    },

    logout() {
      this.$refs.confirmLogoutPop.show();
    },

    showAvatarMenu() {
      this.$refs.avatarMenu.show(this.$els.avatar)
    },

    okcb() {
      ajaxHttp(apiPath.login.logout, {
        type: "POST"
      }).then((res) => {
        this.$refs.confirmLogoutPop.hide()
        sessionStorage.clear();
        clearInterval(this.setIntervalForFetchTip);
        tip('退出成功！');

        window.localStorage.removeItem('loginInfo');
        window.localStorage.removeItem('appBackToken');
        window.AB.TOKEN = '';

        setTimeout(()=>{
          this.$router.go({
            path: '/login'
          });
        }, 3000);

      }).catch((res)=> {
        tip(res.message);
      })
    },

    _initBreadCrumbData({data, path} = {}) {
      if (!data || !path) {
        return false;
      }

      let breadCrumbs = [];
      let indexs = [];

      let search = function(list, index) {
        for(let i = 0, length = list.length; i < length; i++) {
          let e = list[i];
          let link = e.url;
          let sub = e.resources;

          indexs[index] = i;
          breadCrumbs[index] = {
            name: e.description,
            router: link
          };
          if(link && path.indexOf(link) > -1) {

            breadCrumbs[index] = {
              name: e.description,
              router: link
            }

            if (!sub || sub.length === 0) {
              return true;
            } else if(sub && sub.length !== 0 && search(sub, index + 1)) {
              return true;
            }
          }

          if(sub && sub.length !== 0 && search(sub, index + 1)) {
            return true;
          }
        }
        return false;
      };
      if (search(data, 0)) {
        this.$refs.breadCrumb.setPartBreadCrumb(breadCrumbs);
        // 修正菜单切换
        window.AB.componentHub.menus.active.pIndex = indexs[0];
      }

      return false;
    }
  },

  watch: {
    breadCrumbData(val) {
      if (val) {
        this._initBreadCrumbData(val);
      }
    }
  },

  ready() {
    this._init();
  },
  events: {
    toggle(val){
      this.toggleFlag = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/components/layout/header-layout/header-layout.js